module.exports = __webpack_public_path__ + "static/ronnie-thompson-d8891c73052772c420c2329abc16ef7a.jpg";